import React from 'react';
import { useAuth } from '../../AuthProvider';
import text from '../../lib/dictionary.json';
import axios from 'axios';
import { BASE_URL_API, AXIOS_OPTIONS } from '../../Constants';
import Switch from '../reusable/Switch';

const AutoManual = () => {
    const { lang, auto, setAuto, model, user: { type }, setAlertState } = useAuth();

    const toggleAuto = () => {
        setAuto(prev => ({ ...prev, loading: true }));
        const newValue = !auto[model];
        axios.post(
            `${BASE_URL_API}/option/update/${model}-auto`,
            JSON.stringify({ value: newValue }),
            AXIOS_OPTIONS
        ).then(res => {
            setAuto(prev => ({ ...prev, [model]: newValue }));
        }).catch(
            err => setAlertState({ open: true, message: err.response?.data?.message ?? err.message, type: 'error' })
        ).finally(() => setAuto(prev => ({ ...prev, loading: false })));
    };

    return (
        type === 'Admin'
            ? <div className='auto-mode-container' style={{ alignItems: lang === 'en' ? 'flex-start' : 'flex-end' }}>

                {auto.loading
                    ? <div className="switch-container"
                    >
                        <span className='switch-title'>{text[lang]['auto-mode']}</span>
                        <label className="switch-label">({text[lang][model]})</label>
                        <span className='loading-text' style={{
                            fontSize: 'var(--medium)',
                            fontWeight: 'bold',
                            '--cell-background': 'var(--cell-color)'
                        }}>{text[lang]['loading']}</span>
                    </div>
                    : <div className="switch-container"
                    >
                        <span className='switch-title'>{text[lang]['auto-mode']}</span>
                        <Switch
                            value={auto[model]}
                            label={`(${text[lang][model]})`}
                            handler={toggleAuto}
                            alignment={lang === 'en'} />
                    </div>
                }
            </div>
            : <div></div>
    );
};

export default AutoManual;